import { DateInput } from '@mantine/dates';
import PropTypes from 'prop-types';
import React from 'react';
// import styles from './styles.scoped.css';

export default function InputDate({
  input,
  inputProps,
  minDate,
  maxDate,

  // value
  className,

  // label = '',
  // meta = {},
}) {
  const value = input.value;
  const onChange = (e) => {
    input.onChange(e);
  };
  return (
    <div className={className}>
      <DateInput
        {...inputProps}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        required={inputProps?.required}
        styles={{ label: { fontWeight: '600', fontSize: '1rem' } }}
        value={value}
        zIndex={1000}
      />
      <span>{inputProps?.info}</span>
    </div>
  );
}

InputDate.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  label: PropTypes.string,
  maxDate: PropTypes.date,
  meta: PropTypes.object,
  minDate: PropTypes.date,
  value: PropTypes.string,
};
